import * as React from "react";
import Image from "next/image";

import { Grid, Typography, makeStyles } from "@material-ui/core";
import uuid from "react-uuid";

import alarm from "../../../../../../../public/assets/images/op/alarm.png";
import Empty from "../../../static/Empty";

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: "#fff",
    margin: "10px auto",
    padding: "20px 10px",
    border: "solid 1px #B6B3B3",
  },
  p: {
    padding: 10,
  },
  t1: {
    color: "#0A369D",
    fontWeight: "bold",
    fontSize: 18,
    marginBottom: 10,
    marginTop: 10,
  },
  t2: {
    color: "#292929",
    fontSize: 14,
    fontFamily: "Vazir-Bold",
    textAlign: "center",
    marginTop: 10,
  },
  t3: {
    fontSize: 14,
    color: "#292929",
    fontFamily: "Vazir",
    textAlign: "justify",
    lineHeight: "24px",
  },
  card: {
    backgroundColor: "#FAFAFA",
    boxShadow: "1px 2px 10px #29292944",
    padding: "13px 10px",
    borderRadius: "5px",
    width: "13%",
  },
}));

const WorkTime = ({ data }) => {
  const classes = useStyles();
  if (data?.work_days?.length > 0 || data?.rules) {
    return (
      <Grid container className={classes.container} justify="space-between">
        {data?.work_days?.length > 0 ? (
          <>
            <Grid item xs={12} className={classes.p}>
              <Typography variant="h2" className={classes.t1}>
                ساعات کاری
              </Typography>
            </Grid>
            {data.work_days.map((item) => (
              <Grid
                item
                key={uuid()}
                className={classes.card}
                container
                justify="center"
              >
                <Image
                  src={alarm}
                  placeholder="blur"
                  alt="clock"
                  width={40}
                  height={40}
                />
                <Grid item xs={12}>
                  <Typography variant="h4" className={classes.t2}>
                    {item.name}
                  </Typography>
                  <Typography variant="h4" className={classes.t2}>
                    {item.from && item.to
                      ? `${item.from} الی ${item.to}`
                      : "____"}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </>
        ) : (
          <Typography variant="h2" className={classes.t1}>
            اطلاعات ساعت کاری وارد نشده است
          </Typography>
        )}
        {data.rules && (
          <Grid item xs={12} className={classes.p}>
            <Typography variant="h2" className={classes.t1}>
              شرایط پذیرش
            </Typography>

            <Typography variant="h3" className={classes.t3}>
              {data.rules}
            </Typography>
          </Grid>
        )}
      </Grid>
    );
  }
  return <Empty />;
};

export default WorkTime;
